export default "__VITE_ASSET__56xTXao$__"